import { render } from "./MainMenuItem.vue?vue&type=template&id=22168b16&scoped=true&ts=true"
import script from "./MainMenuItem.vue?vue&type=script&lang=ts"
export * from "./MainMenuItem.vue?vue&type=script&lang=ts"

import "./MainMenuItem.vue?vue&type=style&index=0&id=22168b16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22168b16"]])

export default __exports__